import { useCallback, useState } from 'react';
import { CheckIcon, DocumentDuplicateIcon } from '@heroicons/react/24/outline';
import { trackEvent, COPY_CITATION } from '../../utils/googleAnalytics';

export const CopyText = ({ text }) => {
  const [copied, setCopied] = useState(false);

  const setCopiedTimeout = useCallback(() => {
    setCopied(true);
    const t = window.setTimeout(() => setCopied(false), 2000);
    return () => {
      setCopied(false);
      window.clearTimeout(t);
    };
  }, []);

  const handleCopyClick = async e => {
    try {
      e.stopPropagation();

      trackEvent(COPY_CITATION, { text });

      await navigator.clipboard.writeText(text);
      setCopiedTimeout();
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  };

  return (
    <div>
      <div onClick={handleCopyClick} className="cursor-pointer">
        {copied ? <CheckIcon className="h-6" /> : <DocumentDuplicateIcon className="h-6" />}
      </div>
    </div>
  );
};
